import {
  LayoutGrid, ReceiptText, Calculator, Package, Tags, Globe, MessageSquare,
  Percent, Users, Gift, Star, CreditCard, Banknote, BarChart3, Plug, UserCog,
  Settings, Store, Wrench, Handshake, Bot, Server, Bell, DollarSign, Activity, Waypoints, Mail,
} from "lucide-react";

// Every destination. `built` marks the ones with a real screen; the rest show a
// designed placeholder so navigation always works and the shell never breaks.
export const SHOP_OWNER_NAV = [
  { top: true, items: [{ to: "/today", label: "Today", Icon: LayoutGrid, built: true }] },
  { heading: "Sell", items: [
    { to: "/orders", label: "Orders", Icon: ReceiptText, built: true },
    { to: "/counter", label: "Counter", Icon: Calculator, built: true },
    { to: "/shop-page", label: "Shop page", Icon: Globe },
    { to: "/posts", label: "Posts", Icon: MessageSquare, built: true },
  ] },
  { heading: "Stock", items: [
    { to: "/products", label: "Products", Icon: Package, built: true },
    { to: "/categories", label: "Categories", Icon: Tags, built: true },
  ] },
  { heading: "Grow", items: [
    { to: "/deals", label: "Deals", Icon: Percent, built: true },
    { to: "/customers", label: "Customers", Icon: Users },
    { to: "/loyalty", label: "Loyalty", Icon: Gift, built: true },
    { to: "/reviews", label: "Reviews", Icon: Star, built: true },
  ] },
  { heading: "Money", items: [
    { to: "/payments", label: "Payments", Icon: CreditCard },
    { to: "/payouts", label: "Payouts", Icon: Banknote, built: true },
    { to: "/numbers", label: "Numbers", Icon: BarChart3, built: true },
  ] },
  { heading: "Set up", items: [
    { to: "/setup", label: "Set up assistant", Icon: Bot, built: true },
    { to: "/connections", label: "Connections", Icon: Plug, built: true },
    { to: "/team", label: "Team", Icon: UserCog },
    { to: "/shop-settings", label: "Shop settings", Icon: Settings },
  ] },
];

export const PLATFORM_NAV = [
  { top: true, items: [{ to: "/overview", label: "Overview", Icon: LayoutGrid, built: true }] },
  { heading: "Shops", items: [
    { to: "/shops", label: "All shops", Icon: Store },
    { to: "/setting-up", label: "Setting up", Icon: Wrench },
    { to: "/partners", label: "Partners", Icon: Handshake },
  ] },
  { heading: "Platform", items: [
    { to: "/plans", label: "Plans and rates", Icon: Tags },
    { to: "/assistants", label: "Ready-made assistants", Icon: Bot, built: true },
    { to: "/platform-connections", label: "Connections", Icon: Plug, built: true },
    { to: "/email", label: "Email", Icon: Mail, built: true },
    { to: "/mcp-servers", label: "MCP servers", Icon: Server },
    { to: "/tool-connections", label: "Tool connections", Icon: Waypoints, built: true },
  ] },
  { heading: "Health", items: [
    { to: "/alerts", label: "Alerts", Icon: Bell, built: true },
    { to: "/ai-cost", label: "AI cost", Icon: DollarSign, built: true },
    { to: "/activity", label: "Activity log", Icon: Activity },
  ] },
];

export const STAFF_NAV = [
  { top: true, items: [
    { to: "/counter", label: "Counter", Icon: Calculator, built: true },
    { to: "/orders", label: "Orders", Icon: ReceiptText, built: true },
    { to: "/products", label: "Products", Icon: Package, built: true },
  ] },
];

// Mobile bottom bars (5 max). `more` opens the full menu sheet.
export const MOBILE_BARS = {
  shop_owner: [
    { to: "/today", label: "Today", Icon: LayoutGrid },
    { to: "/orders", label: "Orders", Icon: ReceiptText },
    { to: "/counter", label: "Counter", Icon: Calculator },
    { to: "/products", label: "Items", Icon: Package },
    { more: true, label: "More", Icon: Settings },
  ],
  staff: [
    { to: "/counter", label: "Counter", Icon: Calculator },
    { to: "/orders", label: "Orders", Icon: ReceiptText },
    { to: "/products", label: "Items", Icon: Package },
  ],
  platform: [
    { to: "/overview", label: "Overview", Icon: LayoutGrid },
    { to: "/shops", label: "Shops", Icon: Store },
    { to: "/alerts", label: "Alerts", Icon: Bell },
    { more: true, label: "More", Icon: Settings },
  ],
};

export function navForRole(role) {
  if (role === "staff") return STAFF_NAV;
  if (role === "owner" || role === "partner" || role === "helper") return PLATFORM_NAV;
  return SHOP_OWNER_NAV;
}

export function mobileBarForRole(role) {
  if (role === "staff") return MOBILE_BARS.staff;
  if (role === "owner" || role === "partner" || role === "helper") return MOBILE_BARS.platform;
  return MOBILE_BARS.shop_owner;
}
